import React from 'react';

/**
 * Comp-faithful capability/skill chip (the design's `.chip`): a small mono,
 * rounded-full chip on the alt surface. Tones add a colored fill for the
 * profile's "Runs on" template chip etc.
 */

type ChipTone = 'neutral' | 'blue' | 'green' | 'purple' | 'teal';

const toneClass: Record<ChipTone, string> = {
  neutral: 'text-muted bg-surface-alt border-border',
  blue: 'text-accent-text bg-accent-muted border-accent-text/30',
  green: 'text-success-text bg-success-muted border-success-text/30',
  purple: 'text-purple-text bg-purple-muted border-purple-text/30',
  teal: 'text-teal-text bg-teal-muted border-teal-text/30',
};

interface ChipProps {
  tone?: ChipTone;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const Chip: React.FC<ChipProps> = ({ tone = 'neutral', icon, children, className = '' }) => (
  <span
    className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-[7px] py-0.5 font-mono text-[10px] ${toneClass[tone]} ${className}`}
  >
    {icon}
    {children}
  </span>
);
